import * as React from 'react'
import * as Styles from './FreeLecture.style'
import { HttpServer } from '@/services/server'
import FreeLectureType from './types/FreeLectureType'
import FloatCode from './components/FloatCode/FloatCode'
import ISharePopWindowState from './components/SharePopWindow/SharePopWindow'
import { getJsonFromUrl, getUrlParam } from '@/utils/tools'
import FreeLectureList from './components/FreeLectureLise/FreeLectureList'
import TopBanner from './components/TopBanner/TopBanner'
import { appBaseUrl } from '@/config'

declare const Session: any

interface FreeLectureState {
  lectureList: FreeLectureType.IRecommends[]
  title: string
  subtitle: string
  subscribedQrcode: string
  content?: string
  subscribed: boolean
  subscribed_retain: boolean
  isShowFloatCode: boolean
  shareQrcode: string
  isShowSharePopWindow: boolean
  init: boolean
  topCodeImg: string
  nickName: string
  lectureCodeImg: string
}

const today = new Date()
const year = today.getFullYear()
const month = today.getMonth() + 1
const day = today.getDate()
const currentTime = year.toString() + month.toString() + day.toString()

export default class FreeLecture extends React.Component {
  public state: FreeLectureState = {
    lectureList: [],
    title: '',
    subtitle: '',
    subscribedQrcode: '',
    content: '',
    subscribed: false,
    subscribed_retain: false, // 是否是分流号账户
    isShowFloatCode: false,
    shareQrcode: '',
    isShowSharePopWindow: false,
    topCodeImg: 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQFR8TwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyN3FZUDVVV0lkczAxMDAwMDAwN3EAAgQf0hBcAwQAAAAA',
    lectureCodeImg: 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQEt8TwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAya1ZDRDR6V0lkczAxMDAwMGcwNzkAAgQp0hBcAwQAAAAA',
    nickName: '',
    init: false
  }
  public componentDidMount() {
    if (getJsonFromUrl().fr && getJsonFromUrl().fr === 'brand') {
      this.setState({
        topCodeImg: 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQE38TwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAySTBZbTREV0lkczAxMDAwME0wN0YAAgQaIBNcAwQAAAAA',
        lectureCodeImg: 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=gQHi8DwAAAAAAAAAAS5odHRwOi8vd2VpeGluLnFxLmNvbS9xLzAyZHdyNDVRV0lkczAxMDAwMDAwN1oAAgQoIBNcAwQAAAAA'
      })
    }
    document.title = '免费专题'
    HttpServer.getFreeLectureList({ type: 'free_zone' }).then(res => {
      if (res.data.code === 0) {
        this.setState({
          lectureList: res.data.data.recommends,
          init: true
        })
      }
    })
    HttpServer.isSubscribedRetain().then(res => {
      if (res.data.code === 0) {
        this.setState({
          subscribed_retain: res.data.data.subscribed_retain
        })
      }
    })
    HttpServer.getSelfInfo().then(res => {
      if (res.data.code === 0) {
        this.setState(
          {
            subscribed: res.data.data.subscribed,
            nickName: res.data.data.nickname
          },
          () => {
            if (Session.weixinApi) {
              Session.weixinApi.initJSSDK()

              const shareData = {
                title: `${this.state.nickName} 送了你一套免费课`,
                desc: '限时1小时内有效，赶紧领取吧～',
                link: window.location.href,
                imgUrl: 'https://static-1253442168.image.myqcloud.com/picture/7832811_893380d1c4635908af8798b9761234c4.jpg-picmsg420'
              }

              const timeShareData = {
                ...shareData,
                link: `https://share.lizhiweike.com/homepage/freelecture`
              }

              Session.weixinApi.wxShare([shareData, timeShareData], () => {
                this.ifNoSubscribe()
              })
            }
          }
        )
      }
    })
    this.pointLogs()
  }
  public pointLogs = () => {
    const scene = getUrlParam('scene') ? `.${getUrlParam('scene')}` : ''
    try {
      HttpServer.reportServerAPI([
        {
          ubt: `wk.opu9${scene}-freelecture.page`,
          evt: 'view',
          evt_params: {
            inviter_id: getUrlParam('inviter_id')
          }
        }
      ])
    } catch (err) {
      console.log(err)
    }
  }
  public ifNoSubscribe = () => {
    if (!this.state.subscribed) {
      HttpServer.getQrcode({ wtype: 'share_free', last_url: window.location.href }).then(result => {
        if (result.data.code === 0) {
          this.setState(
            {
              shareQrcode: result.data.data.qrcode_content
            },
            () => {
              this.showSharePopWindow()
            }
          )
        }
      })
    }
  }
  public goLecture = (lectureUrl: string, id: number) => {
    const scene = getUrlParam('scene') ? `.${getUrlParam('scene')}` : ''
    try {
      HttpServer.reportServerAPI([
        {
          ubt: `wk.opu9${scene}-freelecture.free_channels`,
          evt: 'click',
          evt_params: {
            inviter_id: getUrlParam('inviter_id'),
            ch_id: id
          }
        }
      ])
    } catch (err) {
      console.log(err)
    }
    setTimeout(() => {
      if (this.state.subscribed) {
        window.location.href = appBaseUrl + lectureUrl + '&st=index_free'
      } else {
        const lastVisitFreeLecture: string | null = window.localStorage.getItem('WKIndex/lastVisitFreeLecture')
        if (!lastVisitFreeLecture || lastVisitFreeLecture === null) {
          window.localStorage.setItem('WKIndex/lastVisitFreeLecture', currentTime)
          this.setState({
            title: '长按扫码关注',
            // subtitle: '领取免费课程',
            subscribedQrcode: this.state.lectureCodeImg,
            // content: '关注领红包',
            isShowFloatCode: true
          })
        } else {
          if (currentTime === lastVisitFreeLecture) {
            window.location.href = appBaseUrl + lectureUrl + '&st=index_free'
          } else {
            window.localStorage.setItem('WKIndex/lastVisitFreeLecture', currentTime)
            this.setState({
              title: '长按扫码关注',
              // subtitle: '领取免费课程',
              subscribedQrcode: this.state.lectureCodeImg,
              // content: '关注领红包',
              isShowFloatCode: true
            })
          }
        }
      }
    }, 100)
  }

  public hideFloatWindow = () => {
    this.setState({
      isShowFloatCode: false,
      isShowSharePopWindow: false
    })
  }

  public showSharePopWindow = () => {
    this.setState({
      isShowSharePopWindow: true
    })
  }

  public showSubscribedCode = () => {
    HttpServer.retainQrcode({ stype: 'freelecture' }).then(result => {
      if (result.data.code === 0) {
        this.setState({
          title: '长按扫码关注',
          subscribedQrcode: `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${result.data.data.ticket}`,
          content: '',
          isShowFloatCode: true
        })
      }
    })
  }

  public render() {
    if (!this.state.init) {
      return null
    }
    return (
      <div className={Styles.main}>
        <div className={Styles.freeLectureListWrap}>
          <TopBanner subscribed={this.state.subscribed} subscribed_retain={this.state.subscribed_retain} showSubscribedCode={this.showSubscribedCode} />
          <FreeLectureList lectureList={this.state.lectureList} goLecture={this.goLecture} />
        </div>
        {this.state.isShowFloatCode ? (
          <FloatCode
            title={this.state.title}
            subtitle={this.state.subtitle}
            subscribedQrcode={this.state.subscribedQrcode}
            content={this.state.content}
            hideFloatWindow={this.hideFloatWindow}
          />
        ) : null}
        {this.state.isShowSharePopWindow ? <ISharePopWindowState shareQrcode={this.state.shareQrcode} hideFloatWindow={this.hideFloatWindow} /> : null}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/FreeLecture/FreeLecture.tsx